module.exports = __webpack_public_path__ + "static/media/Logo.050f53b1.svg";